export default "__VITE_ASSET__BqWX1GxO__"